import React from 'react'
import ComingSoon from '../components/ComingSoon'
import Navbar from '../components/Navbar'

const ComingSoonPage = () => {
  return (
    <div>
        <Navbar />
        <ComingSoon />
    </div>
  )
}

export default ComingSoonPage